import intl from "react-intl-universal";
import {getSnapshot} from "mobx-state-tree";

import {Task} from "@stores/taskLists/gql/serverTypes";
import {deleteTask as deleteTaskRequest} from "../../stores/taskLists/requests/deleteTask";
import {TaskListUnitModelType} from "@stores/taskLists/TaskListUnitModel";
import {TaskListModelType} from "@stores/taskLists/TaskListModel";


import {snackBarRef} from "@stores/snackbarRef";
import {IDataClientService} from "../../platform/services/data/DataClientService";
import {IAuthService} from "../../platform/services/auth/AuthService";


export const deleteTask = async (
    dataClientService: IDataClientService,
    authService: IAuthService,
    task: Task,
    taskListUnitModel: TaskListUnitModelType,
    taskListModel?: TaskListModelType,
) => {
    if (task.taskListId && taskListModel) {
        taskListModel.removeChildId(task.id);
        taskListUnitModel.setTaskList(getSnapshot(taskListModel));
        await taskListUnitModel.save();
    }

    await deleteTaskRequest(dataClientService, authService, task);
    snackBarRef.current?.enqueueSnackbar({
        variant: "success",
        message: intl.get('task.delete.success').d('Task deleted successfully'),
    });
};

